<div
  [style.background]="me ? 'red' : 'var(--tui-secondary)'"
  [style.color]="me ? 'white' : 'black'"
  class="uppercase flex justify-center items-center rounded-full text-[13px] w-[25px] h-[25px] text-center"
>
  {{ initials }}
</div>
